export default {"src":"/_next/static/media/check-icon.01749793.svg","height":88,"width":88,"blurWidth":0,"blurHeight":0};